import { commonSelectors } from "../selector-template-generator";

export const patientsSittingsConfig = {
  fields: [
    {
      name: "start",
      label: "Start",
      hide: true,
    },
    {
      name: "sittings",
      label: "Sittings",
      type: "subform:multiple",
      props: { add: true, delete: true },
      subFormFields: [
        {
          name: "date",
          label: "Date",
          type: "date",
          props: { required: true, pastDatesOnly: true },
        },
        {
          name: "sitting",
          label: "Sitting Type",
          type: "select",
          options: [
            { name: "1st_sitting", label: "Day 1 Sitting" },
            { name: "2nd_sitting", label: "Day 2 Sitting" },
            { name: "3rd_sitting", label: "Day 3 Sitting" },
            { name: "weekly", label: "Weekly Sitting" },
          ],
        },
        {
          name: "notes",
          label: "Notes",
          type: "text",
          props: { multiline: true, required: false },
        },
        {
          name: "trainer",
          label: "Trainer",
          type: "text",
          props: { displayOnly: true, required: false },
        },
      ],
    },
  ],
  collection: (patient) => `CareUsers/${patient}/Data`,
  primaryKey: "start",

  defaults: { sittings: [], start: "sittings" },
};

export const patientsSittingsSelectors = (patient) =>
  commonSelectors(patientsSittingsConfig.collection(patient));

export const postprocessPatientsSittings = (r) => r;

export const validatePatientsSittings = () => "";

export const queryPatientsSittings = (patient) => ({
  collection: patientsSittingsConfig.collection(patient),
  doc: "sittings",
});
